<template>
  <div class="kp-modular-row clearfix">
    <label class="kp-label-aling">{{ label }}</label>
    <input type="range" :min="min" :max="max" :step="step" :value="value">
    <output class="range-output">{{ value }}</output>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'min',
    'max',
    'step',
    'value',
    'move',
    'change',
  ],
  mounted() {
    const input = this.$el.querySelector('input');

    input.addEventListener('input', (event) => {
      this.move(event.target.value);
    });

    input.addEventListener('change', (event) => {
      this.change(event.target.value);
    });
  },
};
</script>



/** WEBPACK FOOTER **
 ** Range.vue?c99272dc
 **/